import React from 'react';
import { Box, Button, IconButton, Typography, Tooltip, Fab } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AddIcon from '@mui/icons-material/Add';

export default function RBCToolbar(props) {
  const goToBack = () => {
    const view = props.view;
    const mDate = props.date;
    let newDate = new Date();
    if (view === 'month') {
      newDate = new Date(mDate.getFullYear(), mDate.getMonth() - 1, 1);
    }
    props.onNavigate('prev', newDate);
  };

  const goToNext = () => {
    const view = props.view;
    const mDate = props.date;
    let newDate = new Date();
    if (view === 'month') {
      newDate = new Date(mDate.getFullYear(), mDate.getMonth() + 1, 1);
    }
    props.onNavigate('next', newDate);
  };

  return (
    <>
      <Box sx={{ display: 'flex', gap: '20px' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'space-between',
            alignItems: 'center',
            width: '28vh'
          }}
        >
          <IconButton sx={{ flex: '1 1 20%' }} onClick={goToBack}>
            <ChevronLeftIcon sx={{ flex: '1 1 20%' }} />
          </IconButton>
          <Typography sx={{ flex: '1 1 60%', textAlign: 'center' }}>{props.label}</Typography>
          <IconButton sx={{ flex: '1 1 20%' }} onClick={goToNext}>
            <ChevronRightIcon />
          </IconButton>
        </Box>
      </Box>
    </>
  );
}
